<template>
	<h1 v-if="sectionTitle != null" class="section__main-heading">
		{{ sectionTitle }}
		<span>{{ sectionExtraTitle }}</span>
	</h1>
</template>

<script setup>
import {useI18n} from '#imports'
const { locale } = useI18n()
import {computed} from "vue";
let sectionTitle
let sectionExtraTitle
const props = defineProps({
	big: Object,
	small: Object
})
if(props.big !== null) {
	sectionTitle = computed(() => locale.value === 'en' ? props.big.en : props.big.jp);
}
if(props.small !== null) {
	sectionExtraTitle = computed(() => locale.value === 'en' ? props.small.en : props.small.jp);
}
</script>

<style lang="scss" scoped>
@use '@/assets/sass/variables.scss' as v;
.section__main-heading {
	font-size: v.$font-size-xl;
	line-height: v.$font-size-xl * 1.25;
	margin: 0 0 1rem 0;
	@include v.respond-to('small') {
		font-size: v.$font-size-xxl;
		line-height: v.$font-size-xxl * 1.25;
		margin: 0 0 2rem 0;
	}
	span {
		display: block;
		font-size: v.$font-size-lg;
		line-height: v.$font-size-lg * 1.25;
		margin: 1.5rem 0 0 0;
	}
}
</style>
